import service from '@/utils/server';

const modName='/md/toxinExemptFreuency/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const updateFreuency = data => {
  return service({
    url: modName + 'updateFreuency',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/toxinExemptFreuency/api/index.js